import { inject, observer } from 'mobx-react'
import React from 'react'
import ModalWrapper from './ModalWrapper'

@inject('workAreaStore', 'store') @observer
class ConfirmModal extends React.Component {

  render(){
    const { closeModal, handleConfirm, confirmText, cancelText, title, body, className } = this.props
    return (
      <ModalWrapper
        className={className}
        close={closeModal}
      >
        <div className='modal-header'>
          <h5 className='modal-title'>
            {title}
          </h5>
        </div>
        <div className='modal-body'>
          <div className='row'>
            <div className='col-12'>
              <span>{body}</span>
            </div>
          </div>
        </div>
        <div className='modal-footer'>
          <button className='btn btn-danger' onClick={closeModal}>
            {cancelText}
          </button>
          <button className='btn btn-primary' onClick={handleConfirm}>
            {confirmText}
          </button>
        </div>
      </ModalWrapper>
    )
  }

}

export default ConfirmModal